import { Recipe } from "./types";

// Grocery Recipes - Single source of truth for all grocery descriptions
export const groceryRecipes: Record<string, Recipe> = {
  "soup-2l": {
    id: "soup-2l",
    name: "2L Soup",
    nameFr: "Pot de 2L",
    nameKey: "recipes.soup2L.name",
    description:
      "Hearty Greek lentil soup or the chef’s soup of the day, simmered with fresh vegetables and aromatic herbs for a comforting, wholesome flavor",
    descriptionFr:
      "Soupe grecque aux lentilles copieuse ou soupe du jour du chef, mijotée avec des légumes frais et des herbes aromatiques pour une saveur réconfortante et nourrissante",
    descriptionKey: "recipes.soup2L.description",
    vegetarian: true,
  },

  "soup-4l": {
    id: "soup-4l",
    name: "4L Soup",
    nameFr: "Pot de 4L",
    nameKey: "recipes.soup4L.name",
    description:
      "A generous 4L of Greek lentil soup or the chef’s soup of the day, rich in flavor, comforting, and perfect for sharing",
    descriptionFr:
      "Pot généreux de 4L de soupe grecque aux lentilles ou soupe du jour du chef, riche en saveurs, réconfortante et idéale pour partager",
    descriptionKey: "recipes.soup4L.description",
    vegetarian: true,
  },

  "dip-tzatziki": {
    id: "dip-tzatziki",
    name: "Tzatziki",
    nameFr: "Tzatziki",
    nameKey: "recipes.dipTzatziki.name",
    description:
      "A refreshing Greek yogurt dip blended with crisp cucumbers, garlic, and fresh dill, delivering creamy, tangy, and aromatic flavors",
    descriptionFr:
      "Trempette grecque rafraîchissante au yogourt mélangé à des concombres croquants, de l’ail et de l’aneth frais, offrant des saveurs crémeuses, acidulées et aromatiques",
    descriptionKey: "recipes.dipTzatziki.description",
    vegetarian: true,
  },

  "dip-taramosalata": {
    id: "dip-taramosalata",
    name: "Taramosalata",
    nameFr: "Taramosalata",
    nameKey: "recipes.dipTaramosalata.name",
    description:
      "Traditional Greek fish roe dip, delicately whipped with olive oil and fresh lemon for a silky, savory spread",
    descriptionFr:
      "Trempette grecque traditionnelle aux œufs de poisson, délicatement fouettée avec de l’huile d’olive et du citron frais pour une texture soyeuse et savoureuse",
    descriptionKey: "recipes.dipTaramosalata.description",
    vegetarian: false,
  },

  "dip-creamy-vinaigrette": {
    id: "dip-creamy-vinaigrette",
    name: "Creamy Vinaigrette",
    nameFr: "Vinaigrette crémeuse",
    nameKey: "recipes.dipCreamyVinaigrette.name",
    description:
      "Velvety house-made vinaigrette, perfectly balanced with herbs and a hint of tang, ideal for dipping or drizzling",
    descriptionFr:
      "Vinaigrette maison veloutée, parfaitement équilibrée avec des herbes et une touche acidulée, idéale pour tremper ou arroser",
    descriptionKey: "recipes.dipCreamyVinaigrette.description",
    vegetarian: true,
  },

  "sauce-mushroom": {
    id: "sauce-mushroom",
    name: "Mushroom Sauce",
    nameFr: "Sauce aux champignons",
    nameKey: "recipes.sauceMushroom.name",
    description:
      "Rich, house-made mushroom sauce with sautéed mushrooms, fresh herbs, and a creamy base, perfect for complementing meats or pasta",
    descriptionFr:
      "Sauce maison riche aux champignons, avec des champignons sautés, des herbes fraîches et une base crémeuse, parfaite pour accompagner viandes ou pâtes",
    descriptionKey: "recipes.sauceMushroom.description",
    vegetarian: true,
  },

  "sauce-pepper": {
    id: "sauce-pepper",
    name: "Pepper Sauce",
    nameFr: "Sauce au poivre",
    nameKey: "recipes.saucePepper.name",
    description:
      "Classic pepper sauce with a subtle kick, made with fresh cracked pepper and a velvety base, ideal for enhancing grilled meats",
    descriptionFr:
      "Sauce classique au poivre avec une subtile touche épicée, préparée avec du poivre frais concassé et une base veloutée, idéale pour rehausser les viandes grillées",
    descriptionKey: "recipes.saucePepper.description",
    vegetarian: true,
  },

  "sauce-meat": {
    id: "sauce-meat",
    name: "Meat Sauce",
    nameFr: "Sauce à la viande",
    nameKey: "recipes.sauceMeat.name",
    description:
      "Savory, house-made meat sauce simmered with fresh tomatoes and aromatic herbs for a hearty and flavorful accompaniment",
    descriptionFr:
      "Sauce à la viande maison savoureuse mijotée avec des tomates fraîches et des herbes aromatiques pour un accompagnement copieux et riche en saveurs",
    descriptionKey: "recipes.sauceMeat.description",
    vegetarian: false,
  },

  "meal-house-rice": {
    id: "meal-house-rice",
    name: "House Rice Dish",
    nameFr: "Plat de riz maison",
    nameKey: "recipes.mealHouseRice.name",
    description:
      "Fluffy house-prepared rice seasoned with aromatic herbs and spices, creating a flavorful and comforting side or main dish",
    descriptionFr:
      "Riz maison moelleux assaisonné d’herbes et d’épices aromatiques, créant un accompagnement ou plat principal savoureux et réconfortant",
    descriptionKey: "recipes.mealHouseRice.description",
    vegetarian: true,
  },

  "meal-greek-potatoes": {
    id: "meal-greek-potatoes",
    name: "Greek Potatoes Dish",
    nameFr: "Plat de patates grecques",
    nameKey: "recipes.mealGreekPotatoes.name",
    description:
      "Golden roasted potatoes tossed with olive oil, garlic, and traditional Greek herbs, offering a fragrant and flavorful side dish",
    descriptionFr:
      "Pommes de terre rôties dorées mélangées à l’huile d’olive, l’ail et des herbes grecques traditionnelles, offrant un accompagnement parfumé et savoureux",
    descriptionKey: "recipes.mealGreekPotatoes.description",
    vegetarian: true,
  },
};
